import { render, staticRenderFns } from "./uaInput.vue?vue&type=template&id=836621ae&scoped=true&"
import script from "./uaInput.vue?vue&type=script&lang=js&"
export * from "./uaInput.vue?vue&type=script&lang=js&"
import style0 from "./uaInput.vue?vue&type=style&index=0&id=836621ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836621ae",
  null
  
)

export default component.exports